import React from 'react'
import styled from 'styled-components'

import AppStoreButton from '~/public/static/images/svg/AppStoreButton.svg'
import GooglePlayButton from '~/public/static/images/svg/GooglePlayButton.svg'
import DesktopContainer from '~/components/DesktopContainer'
import Spacer from '~/components/Spacer'


const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  ${props => props.theme.media.smallDesktop`
    flex-direction: column;
  `};
`

const DownloadInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 65%;
  height: 100%;
  ${props => props.theme.media.smallDesktop`
    align-items: center;
  `};

  ${props => props.theme.media.tiny`
    width: 100%;
  `};
`

const Title = styled.h1`
  font-family: ${props => props.theme.fonts.avenirNextBold};
  ${props => props.theme.media.smallDesktop`
    text-align: center;
    width: 100%;
  `};
  margin-top: 0;

`

const Text = styled.p`
  font-size: 1rem;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  color: ${props => props.theme.colors.text.label};
  max-width: 390px;
  ${props => props.theme.media.smallDesktop`
    text-align: center;
    width: 100%;
  `};

`

const StoresContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 300px;
  ${props => props.theme.media.tiny`
    width: 250px;
  `};
`

const DownloadButton = styled.img`
  width: 141px;
  ${props => props.theme.media.tiny`
    width: 120px;
    height: 100%;
    object-fit: contain;
  `};
`

const DownloadApp = () => {
  return (
    <DesktopContainer>
      <MainContainer>
        <DownloadInput>
          <Title>Download our app!</Title>
          <Text>
            With WinIt, it’s easy to submit evidence or testimony, check the
            status of your dispute, or contact your attorney team, all right
            through the app.
            {' '}
          </Text>
          <Spacer mobile={50} desktop={50} />
          <StoresContainer>
            <a
              href="https://apps.apple.com/us/app/winit-fight-your-tickets/id929918279"
              target="_blank"
              rel="noopener noreferrer"
            >
              <DownloadButton src={AppStoreButton} alt="Download on the App Store" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.winitllc.ticketfighter&hl=en_IE"
              target="_blank"
              rel="noopener noreferrer"
            >
              <DownloadButton src={GooglePlayButton} alt="Get it on Google Play" />
            </a>
          </StoresContainer>
          <Spacer mobile={50} desktop={50} />
        </DownloadInput>
      </MainContainer>
    </DesktopContainer>
  )
}

export default DownloadApp
